import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppStorage } from './appStorage.service';
import { MatDialog } from '@angular/material';
import { ModalNoSesionComponent } from '../components/modal-no-sesion/modal-error-no-sesion.component';

@Injectable()
export class NoAutorizadoInterceptor implements HttpInterceptor {
  constructor(public appStorage: AppStorage, public dialog: MatDialog) {}

  intercept(req, next): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        event => {},
        error => {
          if (error.status === 403) {
            this.mostrarModalSinSesion();
          } else if (error.status === 500) {
            if (
              (error.exception &&
                error.exception.indexOf('io.jsonwebtoken.ExpiredJwtException') >
                  -1) ||
              (error.error && error.error.indexOf('Access Denied') > -1) ||
              (error.error &&
                error.error.exception &&
                error.error.exception.indexOf(
                  'io.jsonwebtoken.ExpiredJwtException'
                ) > -1)
            ) {
              this.mostrarModalSinSesion();
            }
          }
        }
      )
    );
  }

  mostrarModalSinSesion() {
    const dialogRef = this.dialog.open(ModalNoSesionComponent, {
      width: '400px',
      disableClose: true
    });

    return dialogRef;
  }
}
